<!-- 
  使用：
    <Custom-Btn></Custom-Btn>
  属性：
    size="normal"   // normal, small, mini
    type="warnning" // default, warnning, error, primary
    plain="true"    // true, false
 -->
<template>
  <div class="my-custom-btn" :class="GetCustomClass()" @click="$emit('click')">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CustomBtn",
  props: ["type", "size", "plain", "loading"],
  data() {
    return {};
  },
  methods: {
    GetCustomClass() {
      let className = "";
      if (this.type == "default") className = "my-custom-btn-default";
      else if (this.type == "warnning") className = "my-custom-btn-warnning";
      else if (this.type == "error") className = "my-custom-btn-error";
      else if (this.type == "primary") className = "my-custom-btn-primary";
      else className = "my-custom-btn-warnning";
      if (this.size == "normal") className += " my-custom-btn-normal-size";
      else if (this.size == "small") className += " my-custom-btn-small-size";
      else if (this.size == "mini") className += " my-custom-btn-mini-size";
      else className += " my-custom-btn-normal-size";
      if (this.plain) className += " my-custom-btn-plain";
      if (this.loading) className += " my-custom-btn-loading";
      return className;
    }
  }
};
</script>

<style lang="less" scoped>
.my-custom-btn {
  box-sizing: border-box;
  height: 36px;
  padding: 0 20px;
  line-height: 36px;
  opacity: 1;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  cursor: pointer;
  + .my-custom-btn {
    margin-left: 40px;
  }
  &.my-custom-btn-default {
    color: #303133;
    background: #ffffff;
    border: 1px solid #dcdfeb;
    &:hover {
      border: 1px solid #c0c4cc;
    }
  }
  &.my-custom-btn-warnning {
    color: #ffffff;
    background: #ff7e00;
    &:hover {
      background: #ff9a26;
    }
    &.my-custom-btn-plain {
      border: 1px solid #ff7e00;
      color: #ff7e00;
      background: #ffffff;
      &:hover {
        border: 1px solid #ff9a26;
        color: #ff9a26;
      }
    }
  }
  &.my-custom-btn-error {
    color: #ffffff;
    background: #fc4848;
  }
  &.my-custom-btn-primary {
    color: #ffffff;
    background: #4c80fa;
    &:hover {
      background: #719afa;
    }
    &.my-custom-btn-plain {
      border: 1px solid #4c80fa;
      color: #4c80fa;
      background: #ffffff;
      &:hover {
        border: 1px solid #719afa;
        color: #719afa;
      }
    }
    &.my-custom-btn-loading {
      background: #adc5fe;
      &::before {
        content: "";
        display: inline-block;
        width: 20px;
        height: 20px;
        background: url(../../assets/image/loadingicon1.png);
        background-size: cover;
        margin-right: 4px;
        vertical-align: text-top;
        animation: rot 1.5s linear infinite;
      }
    }
  }
  &.my-custom-btn-normal-size {
    height: 36px;
    padding: 0 20px;
    line-height: 36px;
  }
  &.my-custom-btn-small-size {
    height: 32px;
    padding: 0 16px;
    line-height: 32px;
  }
  &.my-custom-btn-mini-size {
    height: 28px;
    padding: 0 12px;
    line-height: 28px;
  }
  @keyframes rot {
    0% {
      -webkit-transform: rotate(0deg);
    }
    25% {
      -webkit-transform: rotate(90deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    75% {
      -webkit-transform: rotate(270deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomComponent/CustomButton.vue